module.exports = __webpack_public_path__ + "static/media/ripley-call-rep-graphic.5236f9f0.png";